import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  tableRow: {
    display: 'grid',
    gridTemplateColumns: '8fr 8fr 4fr 2fr 1fr',
    height: 70,
    alignItems: 'center',
    backgroundColor: theme.palette.background.default,
    borderRadius: 20,
    paddingLeft: 12,
    width: '100%',
    textAlign: 'unset',
    // '&:hover': {
    //   backgroundColor: '#f0f0f0'
    // }
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '3fr 1fr'
    }
  },
  nameCell: {
    display: 'flex'
  },
  skeleton: {
    width: '80%'
  }
}))
export default useStyles
